export default {
  install(Vue) {
    let LOCALE = localStorage.getItem("selectedLocale") || "fr";
    Vue.filter("dateTimeFormat", (date) => {
      return new Intl.DateTimeFormat(LOCALE).format(date);
    });
  }
}
